export default __webpack_public_path__ + "images/CS.27b6cba.png";